import React, { useMemo } from 'react';
import CpanelBreadcrumb from './CpanelBreadcrumb';

const CpanelPageShell = ({
  title,
  subtitle = 'CPanel Administrasi',
  children,
  actions,
  breadcrumbs,
}) => {
  const trail = useMemo(() => {
    if (breadcrumbs?.length) return breadcrumbs;
    return [
      { label: 'CPanel', to: '/cpanel/dashboard' },
      { label: title },
    ];
  }, [breadcrumbs, title]);

  return (
    <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
      <div className="toolbar" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack cpanel-toolbar-container">
          <div className="page-title cpanel-page-title-wrap d-flex flex-column me-3 mb-0">
            <CpanelBreadcrumb items={trail} />
            <h1 className="cpanel-page-title d-flex align-items-center text-dark fw-bolder fs-3 my-1 mb-0">
              <span className="cpanel-page-title__main">{title}</span>
              {subtitle ? (
                <>
                  <span className="cpanel-page-title__divider h-20px border-gray-200 border-start ms-3 mx-2" />
                  <small className="cpanel-page-title__subtitle text-muted fs-7 fw-bold my-1 ms-1">
                    {subtitle}
                  </small>
                </>
              ) : null}
            </h1>
          </div>
          {actions ? (
            <div className="cpanel-toolbar-actions d-flex align-items-center py-1">{actions}</div>
          ) : null}
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" className="container-xxl">
          {children != null ? (
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">{children}</div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CpanelPageShell;
